module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/mywallet/store/deletestore/deletestore.component.css
// module id = ./src/app/mywallet/store/deletestore/deletestore.component.css
// module chunks = main